"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Info_1 = require("@nbc-design/icons/lib/web/Info");
const InfoFill_1 = require("@nbc-design/icons/lib/web/InfoFill");
const popoverBubble_1 = require("./popoverBubble");
require("./popover.css");
/** A popover goes above other content onscreen without an overlay background (on desktop resolutions). The
 * element to trigger popover is passed as children.
 */
exports.Popover = React.forwardRef(({ id = 'popover', title, content, position = 'auto', role = 'tooltip', children, dataTest = 'data-test', iIcon, closeAriaLabel = 'Close popover', isPortal, displayOnlyOne = false, className, onPopoverOpen, onPopoverClose, preventOutsideClick = false, }, ref) => {
    const [iconName, setIconName] = React.useState('info');
    const spanRef = React.useRef(null);
    const portalDivRef = React.useRef(null);
    const [displayPopOver, setDisplayPopOver] = React.useState(false);
    const [referenceElement, setReferenceElement] = React.useState(null);
    React.useEffect(() => {
        displayPopOver ? setIconName('info-fill') : setIconName('info');
    }, [displayPopOver]);
    const togglePopOver = (e) => {
        e.preventDefault();
        // If displayPopOver is at false, that means we are opening the popover
        if (!displayPopOver && onPopoverOpen) {
            onPopoverOpen();
        }
        if (displayPopOver && onPopoverClose) {
            onPopoverClose();
        }
        setDisplayPopOver(!displayPopOver);
    };
    const hidePopOver = React.useCallback(() => {
        if (onPopoverClose) {
            onPopoverClose();
        }
        setDisplayPopOver(false);
    }, [onPopoverClose]);
    React.useEffect(() => {
        const handleBackgroundClick = (e) => {
            if (preventOutsideClick)
                return;
            if ((displayOnlyOne &&
                e.target.closest('.dsc-popover') !== spanRef.current &&
                e.target.closest('.dsc-popover') !== portalDivRef.current) ||
                !e.target.closest('.dsc-popover')) {
                hidePopOver();
            }
        };
        const handleKeyDown = (event) => {
            const { key } = event;
            // When we press enter, calls handleBackgroundClick to close the other popover if displayOnlyOne is set
            if (key === 'Enter') {
                handleBackgroundClick(event);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleBackgroundClick);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleBackgroundClick);
        };
    }, [displayOnlyOne, hidePopOver, preventOutsideClick]);
    React.useImperativeHandle(ref, () => ({
        close: () => {
            hidePopOver();
        },
        open: () => {
            if (onPopoverOpen) {
                onPopoverOpen();
            }
            setDisplayPopOver(true);
        },
        current: spanRef.current,
    }));
    const classes = (0, classnames_1.default)('dsc-popover', !children && 'has-iIcon', className);
    const iconProps = {
        className: 'dsc-popover__iIcon',
        size: iIcon?.size || 'medium',
    };
    const childrenMarkup = children || ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "dsc-popover__btn", "aria-label": iIcon?.title, children: iconName === 'info' ? (0, jsx_runtime_1.jsx)(Info_1.Info, { ...iconProps }) : (0, jsx_runtime_1.jsx)(InfoFill_1.InfoFill, { ...iconProps }) }));
    const addAriaToChildren = (markup) => {
        const ariaProps = {
            ...(role === 'menu'
                ? {
                    id: `${id}__btnTrigger`,
                    'aria-haspopup': true,
                    'aria-controls': `${id}-bubble`,
                    'aria-expanded': !!displayPopOver,
                }
                : {
                    'aria-describedby': displayPopOver ? `${id}-bubble` : undefined,
                }),
        };
        return React.cloneElement(markup, ariaProps);
    };
    return ((0, jsx_runtime_1.jsxs)("span", { className: classes, "data-test": dataTest, ref: spanRef, children: [(0, jsx_runtime_1.jsx)("span", { onClick: togglePopOver, ref: setReferenceElement, className: "dsc-popover__trigger", children: addAriaToChildren(childrenMarkup) }), (0, jsx_runtime_1.jsx)(popoverBubble_1.PopoverBubble, { open: displayPopOver, anchorEl: referenceElement, onClose: (e) => e && togglePopOver(e), title: title, content: content, position: position, role: role, className: (0, classnames_1.default)('dsc-popover__bubble', className), closeAriaLabel: closeAriaLabel, isPortal: isPortal, preventOutsideClick: preventOutsideClick })] }));
});
exports.Popover.displayName = 'Popover';
//# sourceMappingURL=popover.js.map